import { render, staticRenderFns } from "./DiffViewer.vue?vue&type=template&id=56925e8f&scoped=true&"
import script from "./DiffViewer.vue?vue&type=script&lang=js&"
export * from "./DiffViewer.vue?vue&type=script&lang=js&"
import style0 from "./DiffViewer.vue?vue&type=style&index=0&id=56925e8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56925e8f",
  null
  
)

export default component.exports